/**
 * Inactive people (users/{uid}.status === "Inactive") are left out of every
 * list and picker of employees. Their records stay, so names on old tasks,
 * tickets, assets and timecards still resolve through the full user list.
 *
 * Records are hand-edited, so the field turns up as both `status` and `Status`;
 * either one saying Inactive is enough.
 */
export const isActiveUser = (user) =>
  ![user?.status, user?.Status].some((s) => String(s ?? '').trim().toLowerCase() === 'inactive');
